import { toPublicWebUrl } from '#pplx/frontend/common/location.js';
import { redirectWindow } from '#pplx/frontend/platform-components/redirectWindow.js';
// Mirrors the macOS app (SubscriptionURLs.swift in ppl-ai/ios): the desktop
// app sells subscriptions on the public website in the default browser, never
// in-app.
const WEB_SUBSCRIPTION_PATHS = {
    pro: '/pro',
    max: '/max',
};
export function shouldOpenSubscriptionOnWeb() {
    return Boolean(import.meta.env.VITE_IS_PERPLEXITY_DESKTOP_BUILD);
}
export function openWebSubscriptionPage(tier, reason) {
    redirectWindow(toPublicWebUrl(WEB_SUBSCRIPTION_PATHS[tier]), reason);
}
//# sourceMappingURL=webSubscriptionRedirect.js.map